__turbopack_context__.v({
  "capitalize": "Sitemap-module-scss-module__xANrDW__capitalize",
  "categories-list": "Sitemap-module-scss-module__xANrDW__categories-list",
  "category": "Sitemap-module-scss-module__xANrDW__category",
  "category-name": "Sitemap-module-scss-module__xANrDW__category-name",
  "container": "Sitemap-module-scss-module__xANrDW__container",
  "sub-list": "Sitemap-module-scss-module__xANrDW__sub-list",
  "title": "Sitemap-module-scss-module__xANrDW__title",
});
